export default "__VITE_ASSET__v30WWFYP__"